import React from 'react';
import Avatar from 'react-avatar'
import Image from 'react-bootstrap/Image'

function FormImage({ type, name, label, sublabel, register, defaultName, style, ...otherProps}) {

    const {fileSelection} = otherProps;
    const { imageUrl } = otherProps

    const {avatarImage, squareImage} = otherProps;

    const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
        imageUrl ? imageUrl : null
    )

    const [file, setFile] = React.useState(null);
    let fileInput = React.createRef();
    const handleImageChange = e => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
          setFile(file);
          setImagePreviewUrl(reader.result);
          console.log("selected file 1")
          if (fileSelection) {
            console.log("selected file 2")
            fileSelection(file);
          }
        };
        if (file) {
          reader.readAsDataURL(file);
        }
      };
    const handleRemove = () => {
        setFile(null);
        setImagePreviewUrl(null)
        // setImagePreviewUrl(props.avatar ? defaultAvatar : defaultImage);
        fileInput.current.value = null;
        // ref.current.value = null;
    };
    const handleClick = () => {
        fileInput.current.click();
        // ref.current.click()
    };

    const {fullSize} = otherProps;
    var leftCol = fullSize ? "col-md-3" : "col-md-2"
    var rightCol = fullSize ? "col-md-9" : "col-md-6"

    return (
    <div className="form-group row">
        {label && (<label className={`${leftCol} col-form-label`}>
            <h6>{label}</h6>
            {sublabel && (<small>{sublabel}</small>)}
        </label>)}

        <div className={`${rightCol} d-flex align-items-center`}>
          {squareImage ? (
            <div style={{width: "150px", height: "150px"}} className="mr-3">
              <Image thumbnail src={imagePreviewUrl} style={{objectFit: 'cover', objectPosition: 'center', width: '100%', height: '100%'}} />
            </div>
          ) : (<>
            {style ? (
              <div style={style} className="mr-3">
                <Image thumbnail src={imagePreviewUrl} style={{objectFit: 'cover', objectPosition: 'center', width: '100%', height: '100%'}} />
              </div>

            ) : (
              <div style={{width: "100px", height: "100px"}} className="mr-3">
                <Image thumbnail src={imagePreviewUrl} style={{border: "none", borderRadius: "50px", objectFit: 'cover', objectPosition: 'center', width: '100%', height: '100%'}} />
              </div>
              // <Avatar src={imagePreviewUrl} name={defaultName} size={80} round="40px"/>
            )}
          </>)}
          
          
          <input ref={fileInput} style={{display: 'none'}} type="file" accept="image/png, image/jpeg" text="" name={name} onChange={handleImageChange} />
          <button type="button" className="btn btn-primary mx-3 primaryColor" onClick={handleClick}>Choose image</button>
        </div>

    </div>
    );
}

export default FormImage
